import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';

class Question extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/ai-coach-manager-server/api'
  };

  // 陪练小程序1.0 配置查询
  query() {
    return this.get('/manager/coach/config/query');
  }
  // 陪练小程序2.0 配置查询
  query2() {
    return this.get('/manager/coach/config/query2');
  }
  // 陪练小程序1.0 配置更新
  updatePracticeConfig(data: {
    groupDisplayName: string;
    identityDisplayName: string;
    unitDisplayName: string;
    circleDisplayName: string;
  }) {
    return this.post('/manager/coach/config/save', data);
  }
  // 陪练小程序2.0 配置更新
  updatePracticeConfig2(data: {
    groupDisplayName: string;
    identityDisplayName: string;
    unitDisplayName: string;
  }) {
    return this.post('/manager/coach/config/save2', data);
  }

  // 陪练配置更新
  update(id: any, data: object) {
    return this.put(`/manager/coach/config/${id}`, data);
  }

  // logo 查询
  logoQuery() {
    return this.get('/manager/config/query');
  }
  // logo 更新
  logoUpdate(id: any, data: object) {
    return this.post(`/manager/config/save`, data);
  }
}
export default new Question();
